"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FoundationType = void 0;
var FoundationType;
(function (FoundationType) {
    FoundationType["Slab"] = "Slab";
    FoundationType["Basement"] = "Basement";
    FoundationType["CrawlSpace"] = "Crawl Space";
    FoundationType["Open"] = "Open";
    FoundationType["PartialBasement"] = "Partial Basement";
    FoundationType["Piers"] = "Piers";
    FoundationType["Posts"] = "Posts";
    FoundationType["Unknown"] = "Unknown";
})(FoundationType = exports.FoundationType || (exports.FoundationType = {}));
